import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { HiMenuAlt3, HiX } from 'react-icons/hi';

const LOGO_URL = "https://res.cloudinary.com/dghkmujye/image/upload/v1778060091/Picsart_26-05-05_11-57-45-870_1_eutaqj.png";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => setMenuOpen(false), [location]);

  const navStyle = {
    position: 'fixed', top: 0, width: '100%', zIndex: 1000,
    padding: '1rem 2rem',
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    transition: 'all 0.4s ease',
    background: scrolled ? 'rgba(44,24,16,0.97)' : 'transparent',
    backdropFilter: scrolled ? 'blur(10px)' : 'none',
    boxShadow: scrolled ? '0 2px 20px rgba(212,175,55,0.2)' : 'none',
  };

  const linkStyle = {
    color: '#F5D76E', textDecoration: 'none',
    fontFamily: 'Cinzel', fontSize: '0.9rem',
    letterSpacing: '2px', padding: '0.5rem 1rem',
    transition: 'color 0.3s',
  };

  return (
    <>
      <motion.nav style={navStyle} initial={{ y: -80 }} animate={{ y: 0 }} transition={{ duration: 0.6 }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
          {/* Logo in navbar — only visible after scroll on home, always visible on other pages */}
          <motion.img
            src={LOGO_URL}
            alt="Swarn Dhoop"
            animate={{
              opacity: (!isHome || scrolled) ? 1 : 0,
              scale: (!isHome || scrolled) ? 1 : 0.3,
            }}
            transition={{
              duration: 0.6,
              ease: [0.25, 0.46, 0.45, 0.94]
            }}
            style={{ height: '38px', width: '38px', objectFit: 'contain', borderRadius: '50%' }}
          />
          <motion.span
            animate={{ opacity: (!isHome || scrolled) ? 1 : 0 }}
            transition={{ duration: 0.6, ease: [0.25, 0.46, 0.45, 0.94] }}
            style={{ fontFamily: 'Cinzel', color: '#F5D76E', fontSize: '1.2rem', letterSpacing: '3px' }}>
            SWARN DHOOP
          </motion.span>
        </Link>

        {/* Desktop Links */}
        <div style={{ display: 'flex', gap: '1rem' }}>
          <Link to="/" style={linkStyle}>Home</Link>
          <Link to="/products" style={linkStyle}>Products</Link>
        </div>

        {/* Mobile Menu Button */}
        <button onClick={() => setMenuOpen(!menuOpen)}
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#F5D76E', display: 'none' }}
          className="mobile-menu-btn">
          {menuOpen ? <HiX size={28} /> : <HiMenuAlt3 size={28} />}
        </button>

        {/* Mobile Dropdown */}
        {menuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }}
            style={{
              position: 'absolute', top: '100%', left: 0, width: '100%',
              background: 'rgba(44,24,16,0.98)', padding: '1.5rem',
              display: 'flex', flexDirection: 'column', gap: '1rem'
            }}>
            <Link to="/" style={linkStyle}>Home</Link>
            <Link to="/products" style={linkStyle}>Products</Link>
          </motion.div>
        )}
      </motion.nav>

      {/* Hero floating logo — only on home page, disappears on scroll */}
      {isHome && (
        <motion.div
          animate={{
            opacity: scrolled ? 0 : 1,
            scale: scrolled ? 0.3 : 1,
            y: scrolled ? -100 : 0,
          }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          style={{
            position: 'fixed',
            top: '50vh',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 999,
            pointerEvents: 'none',
          }}>
        </motion.div>
      )}
    </>
  );
};

export default Navbar;